export default {
    contactUsList: {
		data: null,
		links: null,
		meta: null,
		rcontactUsId:''
	},
}
